import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-col h-full w-full",
  style: {"background":"rgba(0, 0, 0, 0.8)"}
}
const _hoisted_2 = { class: "flex flex-row justify-between h-16 bg-gray-900 border-b border-gray-800 py-3" }
const _hoisted_3 = { class: "border-l border-gray-800 flex justify-center items-center text-base font-semibold text-gray-500 p-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Year: ")
const _hoisted_5 = { class: "text-gray-300" }
const _hoisted_6 = { class: "bg-gray-900 w-46 p-2" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_NavDropdown = _resolveComponent("NavDropdown")!
  const _component_StudyGallery = _resolveComponent("StudyGallery")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "flex items-center justify-center w-14 focus:outline-none group text-white border-r border-gray-800",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_BaseIcon, {
          name: "close",
          class: "text-xl stroke-1.5"
        })
      ]),
      (_ctx.years.length)
        ? (_openBlock(), _createBlock(_component_NavDropdown, {
            key: 0,
            dark: "",
            "menu-class": "bg-gray-900 mr-2",
            "button-class": "pr-6"
          }, {
            button: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.year), 1)
              ])
            ]),
            menu: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (y) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: y,
                    type: "button",
                    class: "flex w-46 items-center w-full px-4 py-3 font-semibold text-left rounded outline-none text-white hover:bg-gray-500 focus:bg-gray-500",
                    onClick: ($event: any) => (_ctx.year = y)
                  }, _toDisplayString(y), 9, _hoisted_7))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.filteredStudies.length)
      ? (_openBlock(), _createBlock(_component_StudyGallery, {
          key: 0,
          class: "overflow-y-scroll p-12 text-white h-full",
          signs: _ctx.signs,
          studies: _ctx.studiesOfSelectedYear,
          "scan-hover-message": "Select scan",
          dark: "",
          onOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectSeries($event)))
        }, null, 8, ["signs", "studies"]))
      : _createCommentVNode("", true)
  ]))
}